export const HeroSub = ({ css, children }) => {
  return <div className={`hero-sub ${css}`}>{children}</div>;
};
